module.exports = __webpack_public_path__ + "img/login-header.ffc89140.png";